export const TIMEOUTMODAL_TITLE = "Disponibilidad Ocupada o Eliminada";
export const TIMEOUTMODAL_CONTENT =
  "No se ha podido guardar la información porque la disponibilidad fue ocupada o eliminada";
export const TIMEOUTMODAL_BTN_TEXT = "Ver más disponibilidades";
export const TIMEOUTMODAL = "timeout-modal";
export const OUTLINE_CICLE = "mdi-alert-circle-outline";
export const DEFAULT_SCROOLL_TO_TIME = "05:00";
export const ASIGN_APPOINTMENT = "Asignar cita";
